import React from "react";
import { useMDSSession } from "@/mds/components/sessions/session-context";
import { SessionViewExpandedContent } from "./session-view-expanded-content";
import {
  SESSION_CONTAINER_HEIGHT,
  SESSION_CONTAINER_HEIGHT_PREVIEW,
  SessionViewMode,
} from "../../session.constants";

type Props = {};

export const MDSSessionStandardView: React.FC<Props> = () => {
  const {
    finalizedSessionItems,
    sessionStatus,
    activeArtifact,
    sessionConfig,
    sessionViewMode,
    sessionPrevMode,
    internalSessionEvents,
  } = useMDSSession();

  // Derive sessionId from the first session event
  const sessionId = internalSessionEvents[0]?.session_id || "";

  const acceptablePrevStates = [SessionViewMode.Preview];
  const prevContainerHeight = acceptablePrevStates.includes(sessionPrevMode)
    ? SESSION_CONTAINER_HEIGHT_PREVIEW
    : undefined;

  return (
    <SessionViewExpandedContent
      activeArtifact={activeArtifact}
      sessionStatus={sessionStatus}
      sessionItems={finalizedSessionItems}
      sessionId={sessionId}
      sessionConfig={sessionConfig}
      sessionViewMode={sessionViewMode}
      containerHeight={SESSION_CONTAINER_HEIGHT}
      prevContainerHeight={prevContainerHeight}
    />
  );
};
